import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import { TRealtor } from '../../models/realtor';
import { NoPhoto } from './components/NoPhoto';

import * as styles from './styles.css';

interface IAvatarProps {
  isRound: boolean;
  avatarUrl: TRealtor['avatarUrl'];
}

export const Avatar = ({ isRound, avatarUrl }: IAvatarProps) => {
  return (
    <div className={styles['avatar-container']}>
      <div {...mergeStyles(styles['avatar'], isRound && styles['avatar_roundness'])}>
        {avatarUrl ? (
          <div className={styles['avatar_image']} style={{ backgroundImage: `url(${avatarUrl})` }} />
        ) : (
          <NoPhoto className={styles['no_photo']} />
        )}
      </div>
    </div>
  );
};
